// react
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
// store
import { routes } from "../../store/routes";
// components
import RegisterTypeCard from "./RegisterTypeCard";
import { Header, Divider, Button } from "semantic-ui-react";
// others
import { GAPageView, initGA } from "../../index";

// component
function RegisterTypeSelect() {
    // Google analytics
    useEffect(() => {
        initGA();
        GAPageView();
    }, []);

    // template
    return (
        <>
            <style>{`
                .register-type-select-card {
                    padding: 2rem 1.5rem;
                    max-width: 600px;
                    width: 100%;
                    margin: 0 auto;
                    box-sizing: border-box;
                }
                @media (min-width: 768px) {
                    .register-type-select-card {
                        padding: 3rem 2.5rem;
                    }
                }
            `}</style>
            <div className="register-type-select-card" style={{
                background: 'var(--white)',
                borderRadius: '20px',
                border: '1px solid #e0e0e0',
                boxShadow: '0 5px 20px rgba(214, 12, 140, 0.10)',
                position: 'relative',
                width: '100%',
                maxWidth: '600px',
                boxSizing: 'border-box'
            }}>
                <div style={{
                    textAlign: 'center',
                    marginBottom: '2rem'
                }}>
                    <Link to={routes.HOME} style={{ display: 'inline-block', marginBottom: '1.5rem' }}>
                        <img
                            src="/images/logos/logo_dark_version.png"
                            width="180"
                            style={{
                                display: "block",
                                margin: "0 auto",
                                maxWidth: '100%',
                                height: 'auto'
                            }}
                            alt="Activity Point logo"
                        />
                    </Link>
                    <Header as="h2" style={{ marginBottom: '2rem', color: 'var(--dark)' }}>
                        Vyber si jednu z možností
                    </Header>
                </div>

                <div style={{ marginBottom: "2rem" }}>
                    <p style={{
                        margin: "0 0 0.75rem",
                        textAlign: "center",
                        color: "var(--dark)",
                        fontSize: "0.95rem",
                        fontWeight: 600,
                    }}>
                        Účet pre návštevníka
                    </p>
                    <Link to={routes.REGISTER_CLIENT} style={{ textDecoration: "none" }}>
                        <RegisterTypeCard
                            header="Chcem sa registrovať ako užívateľ"
                            icon="futbol outline"
                            text="Vyhľadáš aktivity a prihlásiš sa na termíny."
                        />
                    </Link>
                </div>

                <Divider style={{ margin: '2rem 0' }} />

                <div style={{ textAlign: "center" }}>
                    <Header as="h3" style={{ marginBottom: "0.5rem", color: 'var(--dark)' }}>
                        Registrácia zadávateľa
                    </Header>
                    <p style={{ marginBottom: '1.5rem', color: 'var(--dark)' }}>
                        Vyber si jeden z dostupných programov a vyplň
                        nezaväzný formulár
                    </p>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "0.75rem",
                            marginTop: "1.5rem",
                            flexWrap: "nowrap",
                            justifyContent: "stretch",
                            width: "100%"
                        }}
                    >
                        <Button
                            as={Link}
                            to={routes.AP_SOLIDARITY}
                            style={{
                                background: "linear-gradient(135deg, #3577df 0%, #2a5fbf 100%)",
                                color: "#ffffff",
                                padding: "1.5rem 1rem",
                                fontFamily: "Metropolis Bold",
                                borderRadius: '12px',
                                fontSize: '0.9rem',
                                fontWeight: 'bold',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(53, 119, 223, 0.25)',
                                transition: 'all 0.3s ease',
                                flex: '1 1 auto',
                                textAlign: 'center',
                                width: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 6px 16px rgba(53, 119, 223, 0.35)';
                                e.currentTarget.style.background = 'linear-gradient(135deg, #3d85f0 0%, #3169d0 100%)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(53, 119, 223, 0.25)';
                                e.currentTarget.style.background = 'linear-gradient(135deg, #3577df 0%, #2a5fbf 100%)';
                            }}
                        >
                            #APsolidarity
                        </Button>
                        <Button
                            as={Link}
                            to={routes.AP_BUSINESS}
                            style={{
                                background: "linear-gradient(135deg, #f5c842 0%, #d4a832 100%)",
                                color: "#ffffff",
                                padding: "1.5rem 1rem",
                                fontFamily: "Metropolis Bold",
                                borderRadius: '12px',
                                fontSize: '0.9rem',
                                fontWeight: 'bold',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(245, 200, 66, 0.3)',
                                transition: 'all 0.3s ease',
                                flex: '1 1 auto',
                                textAlign: 'center',
                                width: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 6px 16px rgba(245, 200, 66, 0.4)';
                                e.currentTarget.style.background = 'linear-gradient(135deg, #fdd055 0%, #e0b83d 100%)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(245, 200, 66, 0.3)';
                                e.currentTarget.style.background = 'linear-gradient(135deg, #f5c842 0%, #d4a832 100%)';
                            }}
                        >
                            #APimage
                        </Button>
                        <Button
                            as={Link}
                            to={routes.AP_EVENT}
                            style={{
                                background: "linear-gradient(135deg, #50d90d 0%, #3fb008 100%)",
                                color: "#ffffff",
                                padding: "1.5rem 1rem",
                                fontFamily: "Metropolis Bold",
                                borderRadius: '12px',
                                fontSize: '0.9rem',
                                fontWeight: 'bold',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(80, 217, 13, 0.25)',
                                transition: 'all 0.3s ease',
                                flex: '1 1 auto',
                                textAlign: 'center',
                                width: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 6px 16px rgba(80, 217, 13, 0.35)';
                                e.currentTarget.style.background = 'linear-gradient(135deg, #5ef01a 0%, #4ac00a 100%)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(80, 217, 13, 0.25)';
                                e.currentTarget.style.background = 'linear-gradient(135deg, #50d90d 0%, #3fb008 100%)';
                            }}
                        >
                            #APevent
                        </Button>
                        <Button
                            as={Link}
                            to={routes.AP_ACTION}
                            style={{
                                background: "linear-gradient(135deg, #dc3545 0%, #b02a37 100%)",
                                color: "#ffffff",
                                padding: "1.5rem 1rem",
                                fontFamily: "Metropolis Bold",
                                borderRadius: '12px',
                                fontSize: '0.9rem',
                                fontWeight: 'bold',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(220, 53, 69, 0.25)',
                                transition: 'all 0.3s ease',
                                flex: '1 1 auto',
                                textAlign: 'center',
                                width: '100%'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 6px 16px rgba(220, 53, 69, 0.35)';
                                e.currentTarget.style.background = 'linear-gradient(135deg, #e84555 0%, #c73542 100%)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(220, 53, 69, 0.25)';
                                e.currentTarget.style.background = 'linear-gradient(135deg, #dc3545 0%, #b02a37 100%)';
                            }}
                        >
                            #APwalkIn
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RegisterTypeSelect;
